import { render, staticRenderFns } from "./EditarProfesional.vue?vue&type=template&id=3175cc24&scoped=true"
import script from "./EditarProfesional.vue?vue&type=script&lang=js"
export * from "./EditarProfesional.vue?vue&type=script&lang=js"
import style0 from "./EditarProfesional.vue?vue&type=style&index=0&id=3175cc24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3175cc24",
  null
  
)

export default component.exports